<template>
    <v-container fluid>

        <v-layout row wrap class="hidden-sm-and-up">
            <v-flex xs12>
                <v-tabs
                        color="grey"
                        dark
                        slider-color="yellow"
                >
                    <v-tab ripple to="/particulier">Particulier</v-tab>
                    <v-tab ripple to="/corporatif">Corporatif</v-tab>
                </v-tabs>
            </v-flex>
        </v-layout>

        <br>

        <v-flex xs12>
            <v-img :src="require('../assets/corpo.png')"></v-img>
        </v-flex>

        <v-divider></v-divider>

        <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs10 offset-xs1>
                <div>
                    </br>
                    <h1>Fier d'offrir un service de groupe des plus avantageux!</h1>
                </div>
                <v-divider></v-divider>
                <div>
                    <p>
                        </br>
                        Nous nous déplaçons en entreprise, dans les immeubles à logement, ou dans tout autres lieux
                        et événements pour faire la mise au point de plusieurs vélos.
                        </br>
                        Le service corporatif est convivial et flexible afin d’offrir au groupe une expérience agréable
                        en toute simplicité.
                        </br>
                    </p>
                </div>
            </v-flex>
        </v-layout>
        </v-container>

        <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex x12 class="grey darken-3 white--text">
                </br>
                <h1>Avantages</h1>
                </br>
                <v-divider></v-divider>
                </br>
                    <v-container
                        grid-list-md
                        text-xs-center
                        class="grey darken-3 white--text"
                        >
                        <v-layout row wrap justify-center>
                            <v-flex>
                                <v-card class="orange lighten-1 white--text">
                                    <v-card-title><h1>Simple</h1></v-card-title>
                                    <v-card-text><h3>Simple par notre concept. Les services corporatifs sont offerts
                                        à partir du camion Véloshop.ca complètement aménagé en atelier de vélo selon
                                        les besoins, l'endroit et la disponibilité de votre groupe.
                                    </h3>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-list-tile class="grow">
                                            <v-icon class="white--text">fas fa-arrow-right</v-icon>
                                        </v-list-tile>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex>
                                <v-card class="green lighten-1 white--text">
                                    <v-card-title><h1>Environnement</h1></v-card-title>
                                    <v-card-text><h3>Notre concept permet d’éviter les déplacements en voiture ce qui
                                        contribue à diminuer l’empreinte carbone. Sans oublier que les journées
                                        corporatives Véloshop.ca prônent la mobilité durable en encourageant
                                        l’utilisation d’un transport alternatif et actif.</h3>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-list-tile class="grow">
                                            <v-icon class="white--text">fas fa-arrow-right</v-icon>
                                        </v-list-tile>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex>
                                <v-card class="blue lighten-1 white--text">
                                    <v-card-title><h1>Activité physique</h1></v-card-title>
                                    <v-card-text><h3>Permettre à votre équipe de faire plus de vélo tout en évitant
                                        les déplacements en voiture c’est aussi notre objectif!
                                    </h3>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-list-tile class="grow">
                                            <v-icon class="white--text">fas fa-arrow-right</v-icon>
                                        </v-list-tile>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                            <v-flex>
                                <v-card class="purple lighten-1 white--text">
                                    <v-card-title><h1>Efficace</h1></v-card-title>
                                    <v-card-text><h3>Les journées corporatives Véloshop.ca permettent au groupe de
                                        maximiser leur temps libre. Vos vélos sont réparés pendant notre visite chez
                                        vous. Une shop qui vient à vous et qui est accessible c’est ce que nous
                                        souhaitions avoir en tant que cycliste alors c’est ce que nous vous offrons.
                                    </h3>
                                    </h3></v-card-text>
                                    <v-card-actions>
                                        <v-list-tile class="grow">
                                            <v-icon class="white--text">fas fa-arrow-right</v-icon>
                                        </v-list-tile>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
            </v-flex>
        </v-layout>
        </v-container>


        <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs9 offset-xs2>
                <div>
                    <h1 class="text-uppercase">Comment ça fonctionne?</h1>
                    </br>
                </div>
                <v-divider inset></v-divider>
                <div>
                    </br>
                    <p>Il faut réunir un certain nombre de vélos (pour l’obtention d’un rabais corporatif) et
                        planifier une journée ou nous nous rendons sur le lieu prédéterminé pour faire la réparation
                        des vélos. Ce qui permet aux membres du groupe participant, non seulement d’obtenir, mais
                        également de sauver du temps et des déplacements en voiture.
                        </br></br>
                        Pour réserver votre service corporatif, il suffit de nous contacter!
                        </br>
                        Par téléphone : <a href="tel://1-418-688-3311" class="decoration">(418) 688-3311</a></br>
                        Par courriel : <a href="mailto: info@veloshop.ca" class="decoration">info@veloshop.ca</a>
                    </p>
                </div>
            </v-flex>
        </v-layout>
        </v-container>

        <!-- footer -->
        <v-layout justify-center>
            <v-flex xs12>
                <v-footer
                        dark
                        height="auto">
                    <v-card
                            class="flex"
                            flat
                            tile>
                        <v-card-title class="teal">
                            <h2>SUIVEZ-NOUS!</h2>
                            <v-divider light></v-divider>
                            <v-btn fab light href="https://www.facebook.com/veloshop.ca/" target="_blank">
                                <v-icon size="24px">fab fa-facebook</v-icon>
                            </v-btn>
                            <v-btn fab light href="https://www.instagram.com/veloshop.ca/?hl=en" target="_blank">
                                <v-icon size="24px">fab fa-instagram</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-actions class="grey darken-3 justify-center">
                            &copy;2019 — <strong>Véloshop.ca</strong>
                        </v-card-actions>

                    </v-card>
                </v-footer>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>

    export default {
        name: "Corporatif",
        data: () => ({
            pdf
        })
    }
</script>

<style scoped>
    .decoration {
        text-decoration: none;
    }
</style>
